import React, { useContext, useState } from 'react'
import axios from 'axios';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { signInApi } from '../../Context/api';
import { signInValidation } from '../../Context/validation';
import { toast, ToastContainer } from 'react-toastify';
import { commonMessage, statusCodes } from '../../Constants/generalConfig';
import { useEffect } from 'react';
import ValidationMessage from '../../Component/validationMessage';
import { Notifications } from '../../App';
import Spinner from '../Spinner/spinner';


const Login = () => {
    const [passwordShow, setPasswordShow] = useState(false);
    const {setUserInfo} = useContext(Notifications)
    const [icon, setIcon] = useState(true);
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate();
    const [ip, setIP] = useState('');

    const getData = async () => {
        const res = await axios.get('https://geolocation-db.com/json/')
        setIP(res.data.IPv4)
    }

    useEffect(() => {
        getData()
        if (adminData) {
            navigate('layout/dashboard')
        }
        const disableBackNavigation = (event) => {
            event.preventDefault();
            window.history.forward();
        };
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', disableBackNavigation);
        return () => {
            window.removeEventListener('popstate', disableBackNavigation);
        };
    },[])
    const login = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: signInValidation,
        onSubmit: (values) => {
            const data = {
                email: values.email,
                password: values.password,
                loginDevice: 'WEB',
                deviceId: ip
            }
            setSpinner(true)
            axios.post(signInApi(), { ...data }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    localStorage.setItem("adminData", JSON.stringify(resp.data.data));
                    setUserInfo(resp.data.data)
                    setSpinner(false)
                    if(resp.data.data.roleTitle=='MARKETINGTEAM'){
                        navigate('layout/providerList')
                    }
                    else{
                        navigate('layout/dashboard')
                    }
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                    setSpinner(false)
                })
        }
    })
    return (
        <>
        {spinner ? <Spinner /> : null}
            <ToastContainer />
            <section className="bg_img">
                <section>
                    <div className="col-lg-12">
                        <div className="container">
                            <div className="col-lg-10 mx-auto">
                                <div className="row" style={{ padding: '16% 0' }}>
                                    <div className="col-lg-6 bg_color border_reduas padd_img d-flex justify-content-center">
                                        <img src={require('../../Assets/images/login_img.jpg')} className="border_reduas_2" alt="" />
                                    </div>
                                    <div className="col-lg-6 bg_white border_reduas_1 p-5">
                                        <div className="ps-4 pt-5">
                                            <h1 className="heading_color">Hello!</h1>
                                            <p className="peragraf_color">Sign into your account</p>
                                            <div className="pt-4">
                                                <div className="input-group mb-4">
                                                    <span className="input-group-text" id="basic-addon1"
                                                    ><svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="30"
                                                        height="30"
                                                        viewBox="0 0 24 24"
                                                    >
                                                            <path
                                                                fill="#F47E3B"
                                                                d="M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m0 2l-6.5 4.47a1 1 0 0 1-1 0L5 6Z"
                                                            />
                                                        </svg>
                                                    </span>
                                                    <input className="form-control form-control_Style" type="email" placeholder="Email" name="email" onChange={login.handleChange} alue={login.values.email} />
                                                    <ValidationMessage name='email' formName={login} />
                                                </div>
                                                <div className="input-group mb-4 mt-4 position-relative">
                                                    <span className="input-group-text" id="basic-addon1"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 24 24">
                                                            <path fill="#F47E3B" d="M12 17a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2zm-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3" />
                                                        </svg>
                                                    </span>
                                                    <input className="form-control form-control_Style" type={passwordShow ? "text" : "password"} placeholder="Pin" name="password"
                                                        onChange={login.handleChange}
                                                        value={login.values.password}
                                                        maxLength={4}
                                                        onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                                                    />
                                                    <ValidationMessage name='password' formName={login} />
                                                    <span className="position_forgot forgot_pin cursor" onClick={() => navigate('forgotPin')}>Forgot password?</span>
                                                    <span className="position_eye ">
                                                        {icon ? (
                                                            <i className="fa fa-eye" style={{ color: '#F7A77A' }} onClick={() => { setPasswordShow(true); setIcon(false) }}></i>
                                                        ) : (
                                                            <i className="fa fa-eye-slash" aria-hidden="true" style={{ color: '#F7A77A' }} onClick={() => { setPasswordShow(false); setIcon(true) }}></i>
                                                        )}
                                                    </span>
                                                </div>
                                                <div className="pt-4">
                                                    <button className="my_btn" onClick={login.handleSubmit}>Sign In</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}

export default Login;


